module.exports = __webpack_public_path__ + "img/9791185786360.fe15289b.jpg";